export default __webpack_public_path__ + "static/WildfirePrevention-7a9317d74898af44f535135705194399.mp4";